import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Label } from 'semantic-ui-react';
import TargetLink from '../target-link';

const style = {
  color: '#20c49e',
  opacity: 1,
};

const DuplicatedInfluencerError = ({
  duplicateInfluencerPlatform,
  platform,
  duplicateInfluencerLinkId,
  duplicateInfluencerHandle,
}) => {
  const shouldRender = _.eq(duplicateInfluencerPlatform, platform);
  if (!shouldRender) return null;
  return (
    <Label basic color="red" pointing>
        An influencer with this handle({duplicateInfluencerHandle}) already exists.
        Click <TargetLink style={style} renderIf href={`/influencer/${duplicateInfluencerLinkId}/statistics`}>here</TargetLink> to view {'influencer\'s'} page.
    </Label>
  );
};

DuplicatedInfluencerError.propTypes = {
  duplicateInfluencerPlatform: PropTypes.string,
  platform: PropTypes.string,
  duplicateInfluencerLinkId: PropTypes.string,
  duplicateInfluencerHandle: PropTypes.string,
};

DuplicatedInfluencerError.defaultProps = {
  duplicateInfluencerPlatform: null,
  platform: null,
  duplicateInfluencerLinkId: null,
  duplicateInfluencerHandle: null,
};


export default DuplicatedInfluencerError;



/** WEBPACK FOOTER **
 ** ./src/components/duplicated-influencer-error/index.js
 **/